$(document).ready(function() {

  $(document).on("click", ".color_filter_item", function(event) {
     let filter_value = $(this).attr('filter_value');
     $('.thb-filter[filter_name="Color Swatches"] .facet-checkbox[filter_value="'+filter_value+'"]').click();
   });
  
    $(document).on("click", ".free-gift-action", function(event) {
    event.preventDefault();

    let button = $(this);
    button.addClass('btn_disabled');

    let variantId = parseInt(button.attr("data-vid"), 10);
    let productEligible = button.attr("product_eligible") === 'true';

    if (!productEligible || !variantId) {
        console.warn("Invalid variant ID or product not eligible.");
        button.removeClass('btn_disabled');
        return;
    }
    $.ajax({
        url: "/cart.js",
        method: "GET",
        dataType: "json",
        success: function(cart) {
            const freeGiftElement = document.querySelector('.free-gift--text');
            if (!freeGiftElement) {
                console.warn("Missing .free-gift--text element.");
                button.removeClass('btn_disabled');
                return;
            }

    
            let freeGiftIds = freeGiftElement.getAttribute('free_gift_products');
            if (!freeGiftIds) {
                console.warn("No free gift IDs defined.");
                button.removeClass('btn_disabled');
                return;
            }

            const freeGiftVariantIds = freeGiftIds.split(',').map(id => parseInt(id.trim(), 10));

            
            const alreadyHasGift = cart.items.some(item => freeGiftVariantIds.includes(item.id));

            if (alreadyHasGift) {
                alert("You already have a free gift in your cart!");
                button.removeClass('btn_disabled');
                return;
            }
            $.ajax({
                url: "/cart/add.js",
                method: "POST",
                contentType: "application/json",
                data: JSON.stringify({ id: variantId, quantity: 1 }),
                success: function() {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                },
                error: function(xhr, status, error) {
                    console.error("Error adding free gift:", error);
                },
                complete: function() {
                    button.removeClass('btn_disabled');
                }
            });
        },
        error: function() {
            console.error("Error fetching cart.");
            button.removeClass('btn_disabled');
        }
    });
});


$(document).on("click", ".free_gift__size", function() {
    var free_id = $(this).attr('data-variant-id');
    $('.free_gift__size').removeClass('active');
    $(this).addClass('active');
    $('.free-gift-action').attr('data-vid', free_id);
});

document.addEventListener("line-item:change:end", function() {
    setTimeout(function() {
        let freeGiftElement = document.querySelector('.free-gift--text');
        if (!freeGiftElement) return;

        let freeItemIds = freeGiftElement.getAttribute('free_gift_products');
        if (!freeItemIds) return;

        let freeItemThreshold = parseInt(freeGiftElement.getAttribute('free_gift_threshold'), 10);
        freeItemIds = freeItemIds.split(',').map(id => parseInt(id.trim(), 10));

        fetch("/cart.js")
            .then(response => response.json())
            .then(cart => {
                cart.items.forEach(item => {
                    if (freeItemIds.includes(item.id) && cart.total_price < freeItemThreshold) {
                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ id: item.key, quantity: 0 })
                        })
                        .then(() => {
                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                        })
                        .catch(error => console.error("Error removing free gift:", error));
                    }
                });
            })
            .catch(error => console.error("Error fetching cart:", error));
    }, 500);
});

  
});



function moveTextWithLink() {
  const textWithLink = document.querySelector('.text_with_link_wr');
  const productCount = document.querySelector('.product_count');
  const textWithLinkContainer = document.querySelector('.text-with-link');

  if (!textWithLink || !productCount || !textWithLinkContainer) return;

  if (window.innerWidth > 768) {
    // Move after .product_count if not already placed
    if (textWithLink.previousElementSibling !== productCount) {
      productCount.parentNode.insertBefore(textWithLink, productCount.nextSibling);
    }
  } else {
    // Append inside .text-with-link if not already there
    if (textWithLink.parentNode !== textWithLinkContainer) {
      textWithLinkContainer.appendChild(textWithLink);
    }
  }
}

// Run on load
moveTextWithLink();

// Run on resize
window.addEventListener('resize', moveTextWithLink);


//---------------------------- Help Center Page FAQ --------------------------------
function initFaqSection(section) {
    const filters = section.querySelectorAll(".faq-filter");
    const faqItems = section.querySelectorAll(".faq-item");
    const faqQuestions = section.querySelectorAll(".faq-question");

    function toggleHandler(e) {
      const question = e.currentTarget;
      const item = question.closest(".faq-item");

      if (!item.classList.contains("active")) return;

      const allItems = section.querySelectorAll(".faq-item.active");

      allItems.forEach(other => {
        if (other !== item) {
          other.classList.remove("open");
          const toggle = other.querySelector(".faq-toggle");
          if (toggle) toggle.textContent = "+";
        }
      });

      const isOpen = item.classList.contains("open");
      item.classList.toggle("open", !isOpen);

      const toggle = item.querySelector(".faq-toggle");
      if (toggle) toggle.textContent = isOpen ? "+" : "×";
    }

    function activateFilter(button) {
      const filterId = button.getAttribute("data-filter");

      filters.forEach(f => f.classList.remove("active"));
      button.classList.add("active");

      faqItems.forEach(item => {
        const match = item.getAttribute("data-category") === filterId;
        item.classList.toggle("active", match);
        item.classList.remove("open");
        const toggle = item.querySelector(".faq-toggle");
        if (toggle) toggle.textContent = "+";
      });
    }

    const initialFilter = section.querySelector(".faq-filter");
    if (initialFilter) activateFilter(initialFilter);

    filters.forEach(filter => {
      filter.addEventListener("click", () => activateFilter(filter));
    });

    // Toggle Handler immer setzen – unabhängig von Sichtbarkeit
    faqQuestions.forEach(question => {
      question.removeEventListener("click", toggleHandler);
      question.addEventListener("click", toggleHandler);
    });
  }

  function initAllFaqSections() {
    if (document.querySelectorAll(".faq-section").length) {
      document.querySelectorAll(".faq-section").forEach(initFaqSection);
    }
  }

  document.addEventListener("DOMContentLoaded", initAllFaqSections);
  // document.addEventListener("shopify:section:load", function (event) {
  //   const section = event.target.querySelectorAll(".faq-section");
  //   if (section) {
  //     initFaqSection(section);
  //   }
  // });



document.addEventListener('DOMContentLoaded', () => {
  const isDesktop = () => window.innerWidth > 1024;

  const bindScrollAndDrag = (el) => {
    if (!el || el.dataset.scrollBound === 'true') return;
    if (!isDesktop()) return; 
    if (el.scrollWidth <= el.clientWidth) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;

    const startDrag = (e) => {
      if (e.pointerType === 'touch') return; 
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = el.scrollLeft;
      el.classList.add('dragging');
      el.style.cursor = 'grabbing';
      e.preventDefault();
    };

    const onMove = (e) => {
      if (!isDown) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true; 
      el.scrollLeft = scrollLeft - dx;
    };

    const stopDrag = () => {
      if (!isDown) return;
      isDown = false;
      el.classList.remove('dragging');
      el.style.cursor = 'grab';
    };
    el.addEventListener('click', (e) => {
      if (moved) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);

    el.addEventListener('pointerdown', startDrag, { passive: false });
    el.addEventListener('pointermove', onMove, { passive: true });
    el.addEventListener('pointerup', stopDrag, { passive: true });
    el.addEventListener('pointerleave', stopDrag, { passive: true });
    el.addEventListener('wheel', (e) => {
      if (e.deltaY !== 0) {
        e.preventDefault();
        el.scrollLeft += e.deltaY;
      }
    }, { passive: false });

    el.dataset.scrollBound = 'true';
  };

  const observer = new MutationObserver(() => {
    document.querySelectorAll('.free-gift-products-wrapper').forEach(bindScrollAndDrag);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.querySelectorAll('.free-gift-products-wrapper').forEach(bindScrollAndDrag);
});

